import type { IkasProduct } from ".";
import { initIkasProductVariantType } from "./variant-type/init";
import { initIkasProductVariant } from "./variant/init";
import { initIkasProductAttributeValue } from "./attribute-value/init";
import { initIkasBrand } from "../brand/init";
import { initIkasCategory } from "../category/init";
import { initIkasHTMLMetaData } from "../html-meta-data/init";

export function initIkasProduct(product: IkasProduct, locale: string | null) {
  product.metaData && initIkasHTMLMetaData(product.metaData, locale);
  product.brand && initIkasBrand(product.brand, locale);
  product.categories.forEach((c) => initIkasCategory(c, locale));
  product.variants.forEach(initIkasProductVariant);
  product.attributes.forEach(initIkasProductAttributeValue);
  product.variantTypes.forEach(initIkasProductVariantType);
}
